module.exports = __webpack_public_path__ + "img/pinterest-p.7f6ea8ed.svg";